import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: { id: 'Homepage icons', defaultMessage: 'Homepage icons' },
  icons: { id: 'Icons', defaultMessage: 'Icons' },
  image: { id: 'Image', defaultMessage: 'Image' },
  iconTitle: { id: 'Title', defaultMessage: 'Title' },
  link: { id: 'Link', defaultMessage: 'Link' },
});

const IconSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.icons),
  fieldsets: [
    { id: 'default', title: 'Default', fields: ['image', 'title', 'link'] },
  ],
  properties: {
    image: {
      title: intl.formatMessage(messages.image),
      widget: 'object_browser',
      mode: 'image',
      return: 'single',
      selectableTypes: ['icona_rectificada_pagina_principal'],
      initialPath: '/icones-pagina-inicial',
      selectedItemAttrs: ['@type', 'title', 'image_field', 'image_scales'],
    },
    title: { title: intl.formatMessage(messages.iconTitle) },
    link: { title: intl.formatMessage(messages.link), widget: 'url' },
  },
  required: ['image', 'title', 'link'],
});

export const HomepageIconsSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [{ id: 'default', title: 'Default', fields: ['icons'] }],
  properties: {
    icons: {
      title: intl.formatMessage(messages.icons),
      widget: 'object_list',
      schema: IconSchema({ intl }),
    },
  },
  required: [],
});
